import {
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import "moment/locale/es";
import { Delete } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { conveniosConfirmarPracticas } from "../../../actions/contrataciones/contratacionesConvenios";
import ConveniosNomencladosDeletePrev from "./ConveniosNomencladosDeletePrev";

export const ConveniosNomencladosPrevisualizacion = (props) => {
  const dispatch = useDispatch();
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const { dataPrevisualizacion } = useSelector(
    (state) => state.contratacionesConvenios
  );
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const [idCapituloEdit, setIdCapituloEdit] = useState(0);

  const [dataPrevisualizacionArray, setDataPrevisualizacionArray] = useState(
    []
  );

  useEffect(() => {
    setDataPrevisualizacionArray([...dataPrevisualizacion]);
  }, [dataPrevisualizacion]);

  const deleteHandler = (e) => {
    e.preventDefault();

    let target = e.target;

    while (target && target.nodeName !== "TR") {
      target = target.parentNode;
    }
    if (target) {
      const idCapitulo = Number(target.attributes.capitulo.value.slice(9));

      setIdCapituloEdit(idCapitulo);
      setShowDialogDelete(true);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const prevFormateada = dataPrevisualizacionArray.map(
      (capitulo, index) => {
        return {
          ...capitulo,
          valor: parseFloat(e.target[`valor-${index}`].value),
        };
      }
    );

    const dataFormateada = {
      galenosGastos: [...prevFormateada],
      practicaDesde: props.formValues.codDesde?.codNom,
      practicaHasta: props.formValues.codHasta?.codNom,
      redondeo: props.formValues.redondeo,
      fechaInicioVigencia: props.formValues.fechaInicioVigencia,
      idCategoria: props.formValues.idCategoria,
      idEfectorFacturacion: dataContrato.idEfectorFacturacion,
    };

    dispatch(
      conveniosConfirmarPracticas(
        dataFormateada,
        props.closeModalPracticasHandler
      )
    );
  };

  return (
    <React.Fragment>
      <ConveniosNomencladosDeletePrev
        showDialogDelete={showDialogDelete}
        setShowDialogDelete={setShowDialogDelete}
        idCapituloEdit={idCapituloEdit}
        dataPrevisualizacionArray={dataPrevisualizacionArray}
        setDataPrevisualizacionArray={setDataPrevisualizacionArray}
      />
      <ValidatorForm onSubmit={submitHandler}>
        {dataPrevisualizacionArray.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Desde Cod</TableCell>
                <TableCell>Hasta Cod</TableCell>
                <TableCell style={{width: "10%"}}>Valor</TableCell>
                <TableCell>Galeno</TableCell>
                <TableCell>Gasto</TableCell>
                <TableCell style={{width: "15%"}}>Fecha Inicio Vigencia</TableCell>
                <TableCell style={{width: "10%"}}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataPrevisualizacionArray?.map((capitulo, index) => {
                return (
                  <TableRow key={index} capitulo={`capitulo-${index}`}>
                    <TableCell>{capitulo.codigoPracticaDesde}</TableCell>
                    <TableCell>{capitulo.codigoPracticaHasta}</TableCell>
                    <TableCell>
                      <TextValidator
                        margin="normal"
                        fullWidth
                        autoComplete="off"
                        name={`valor-${index}`}
                        defaultValue={capitulo.valor}
                        validators={["isFloat"]}
                        errorMessages={["Solo numeros"]}
                      />
                    </TableCell>
                    <TableCell>{capitulo.galeno}</TableCell>
                    <TableCell>{capitulo.idGasto !== 1 && capitulo.gasto}</TableCell>
                    <TableCell>
                      {new Date(
                        capitulo.fechaInicioVigencia
                      ).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        startIcon={<Delete />}
                        onClick={deleteHandler}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography style={{ margin: "2rem", fontStyle: "italic" }}>
            No hay capitulos para previsualizar
          </Typography>
        )}
        <Button
          variant="contained"
          color="primary"
          style={{ margin: "1.5rem" }}
          onClick={() => {
            props.closeModalPracticasHandler();
            props.setShowPrevisualizacion(false);
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: "1.5rem" }}
          type="submit"
        >
          Confirmar
        </Button>
      </ValidatorForm>
    </React.Fragment>
  );
};
